import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const LabsFooter: React.FC = () => {
  const navigate = useNavigate();

  return (
    <section id="footer-cta" className="relative py-32 px-6 sm:px-8 lg:px-12 border-t border-[#1F1F2E]/50">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-[#3B82F6]/5 rounded-full blur-[120px]" />
      </div>

      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="font-space-grotesk text-4xl sm:text-5xl md:text-6xl font-bold text-white mb-6 leading-[0.95]"
        >
          The infrastructure is built.
          <br />
          The distribution is live.
          <br />
          <span className="bg-gradient-to-r from-[#3B82F6] to-[#8B5CF6] bg-clip-text text-transparent">
            We need builders.
          </span>
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.1 }}
          className="text-[#A1A1AA]/60 text-sm sm:text-base mb-12 max-w-xl mx-auto leading-relaxed"
        >
          Noa Labs is recruiting founding teams for each Auto AI vertical. Joint venture equity. Revenue sharing. 2,400 dealerships from day one. No cold calls.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
          className="mb-16"
        >
          <a
            href="mailto:labs@noa-partners.com"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-gradient-to-r from-[#3B82F6] to-[#8B5CF6] text-white font-medium text-sm hover:shadow-[0_0_40px_rgba(59,130,246,0.25)] transition-shadow"
          >
            Apply to the Builder in Residence Program
          </a>
        </motion.div>

        <div className="flex items-center justify-center gap-6 text-xs text-[#A1A1AA]/30">
          <button
            onClick={() => navigate('/')}
            className="hover:text-[#A1A1AA]/60 transition-colors"
          >
            Learn more about Noa Partners
          </button>
          <span>|</span>
          <button
            onClick={() => document.getElementById('verticals')?.scrollIntoView({ behavior: 'smooth' })}
            className="hover:text-[#A1A1AA]/60 transition-colors"
          >
            View all Noa Labs verticals
          </button>
        </div>
      </div>

      <div className="mt-20 pt-8 border-t border-[#1F1F2E]/30 text-center">
        <p className="text-[10px] text-[#A1A1AA]/15 uppercase tracking-[0.2em]">
          © {new Date().getFullYear()} Noa Labs — A Noa Partners venture studio
        </p>
      </div>
    </section>
  );
};

export default LabsFooter;
